module.exports = __webpack_public_path__ + "img/VOLLEY.5afb4d68.png";